import { Topbar } from '@layouts/Library/Topbar'

interface CheckoutProps {
	children: React.ReactNode
}

export function LibraryLayout({ children }: CheckoutProps) {
	return (
		<div className='w-full min-h-screen flex flex-col items-center relative'>
			<Topbar />
			<div className='flex flex-col w-full min-h-[_calc(100vh_-_118px)] overflow-clip relative'>
				{children}

				<div>
					<img
						src='/imgs/admin/lines-bottom-right.png'
						alt='Emoji'
						className='absolute bottom-0 right-0 w-[480px] h-[843px]'
					/>
				</div>
			</div>
		</div>
	)
}
